/**
 * @license
 * Copyright (c) 2011 %CURRENT_YEAR%, Oracle and/or its affiliates.
 * Licensed under The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { NONE, ERROR, WARN, INFO, LOG } from './logLevels';
import { LogLevelType } from './logger';

/*
 * Helper method that retrieves and parses session storage setting
 */
const _getSessionStorage = () => {
  let logLevel: LogLevelType | undefined;
  try {
    const sessionValue = window?.sessionStorage?.getItem('ojet.logLevel');
    switch (sessionValue) {
      case 'none':
        logLevel = NONE;
        break;
      case 'error':
        logLevel = ERROR;
        break;
      case 'warning':
        logLevel = WARN;
        break;
      case 'info':
        logLevel = INFO;
        break;
      case 'log':
        logLevel = LOG;
        break;
      default:
        logLevel = undefined;
    }
    // eslint-disable-next-line no-empty
  } catch (e) {}

  return logLevel;
};

/**
 * SessionStorage setting
 */
export const sessionStorageLevel = _getSessionStorage();
